"use client"

import { Button } from "@/components/ui/button"
import { StickyNote, X } from "lucide-react"

interface NoteHelperProps {
  show: boolean
  onDismiss: () => void
}

export function NoteHelper({ show, onDismiss }: NoteHelperProps) {
  if (!show) return null

  return (
    <div className="mb-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded-md flex items-start justify-between">
      <div className="flex items-start">
        <StickyNote className="h-5 w-5 text-blue-500 mt-0.5 mr-2" />
        <div>
          <h3 className="font-medium text-blue-800">New Feature: Candidate Notes</h3>
          <p className="text-blue-700 text-sm">
            You can now add notes to candidates by clicking the "Add Note" button in each row. Notes are saved
            automatically and can be edited at any time.
          </p>
        </div>
      </div>
      <Button variant="ghost" size="sm" onClick={onDismiss} className="text-blue-700 hover:bg-blue-100">
        <X className="h-4 w-4" />
      </Button>
    </div>
  )
}
